<script lang="ts" setup>
import RoomieButton from '@lahaus-roomie/roomie/src/components/RoomieButton/index.vue'
import RoomieCardLink from '@lahaus-roomie/roomie/src/components/RoomieCardLink/index.vue'
import type { Option, Props } from './types'
import './_index.scss'

defineProps<Props>()
const { t, rt, tm } = useI18n()
const emit = defineEmits(['submit', 'skip'])

const options = tm('options') as Array<Option>

const handleOptionClick = (value: string) => {
  emit('submit', { name: 'deliveryTerm', value: value || null })
}

const handleSkip = () => {
  emit('skip', { name: 'deliveryTerm', value: null })
}
</script>

<script lang="ts">
export default {
  name: 'OnboardingStepsDeliveryTerm'
}
</script>

<template>
  <section class="onboarding-steps-delivery-term">
    <h2 class="text-carbon-800 text-20 font-semibold mb-8 text-center">
      {{ t('title') }}
    </h2>

    <div class="onboarding-steps-delivery-term__options-holder">
      <RoomieCardLink
        v-for="(option, index) in options"
        :id="`delivery-term-option-${index}`"
        :key="`delivery-term-option-${index}`"
        :data-lh-id="`onboarding-delivery-term-option-${index}`"
        class="cursor-pointer"
        container-tag="div"
        :title="rt(option.label)"
        :icon-name="rt(option.icon)"
        :interactive="true"
        :can-right-arrow="true"
        @click="() => handleOptionClick(rt(option.value))" />
    </div>

    <div class="w-full mt-12 flex justify-center">
      <RoomieButton
        id="onboarding-steps-delivery-term-skip-button"
        data-lh-id="onboarding-steps-delivery-term-skip-button"
        type="button"
        :aria-label="t('skipCta')"
        variant="ghost"
        @click="handleSkip">
        {{ t('skipCta') }}
      </RoomieButton>
    </div>
  </section>
</template>

<i18n src="./i18n.json" lang="json" />
